import { useContextSelector } from 'use-context-selector'

import { OccurrencesModalContext } from '../context/OccurrencesModalProvider'

export const useOccurrencesModal = () => {
  const close = useContextSelector(
    OccurrencesModalContext,
    (occurrences) => occurrences.close
  )

  const isOpen = useContextSelector(
    OccurrencesModalContext,
    (occurrences) => occurrences.isOpen
  )

  const open = useContextSelector(
    OccurrencesModalContext,
    (occurrences) => occurrences.open
  )

  const options = useContextSelector(
    OccurrencesModalContext,
    (occurrences) => occurrences.options
  )

  const selectedOccurrences = useContextSelector(
    OccurrencesModalContext,
    (occurrences) => occurrences.selectedOccurrences
  )

  const setSelectedOccurrences = useContextSelector(
    OccurrencesModalContext,
    (occurrences) => occurrences.setSelectedOccurrences
  )

  const pendingConfirmOccurrence = useContextSelector(
    OccurrencesModalContext,
    (occurrences) => occurrences.pendingConfirmOccurrence
  )

  const setPendingConfirmOccurrence = useContextSelector(
    OccurrencesModalContext,
    (occurrences) => occurrences.setPendingConfirmOccurrence
  )

  const modalContentTemplate = useContextSelector(
    OccurrencesModalContext,
    (occurrences) => occurrences.modalContentTemplate
  )

  const setModalContentTemplate = useContextSelector(
    OccurrencesModalContext,
    (occurrences) => occurrences.setModalContentTemplate
  )

  const breadcrumbOccurrences = useContextSelector(
    OccurrencesModalContext,
    (occurrences) => occurrences.breadcrumbOccurrences
  )

  const setBreadcrumbOccurrences = useContextSelector(
    OccurrencesModalContext,
    (occurrences) => occurrences.setBreadcrumbOccurrences
  )

  const displayedOccurences = useContextSelector(
    OccurrencesModalContext,
    (occurrences) => occurrences.displayedOccurences
  )

  const setDisplayedOccurrences = useContextSelector(
    OccurrencesModalContext,
    (occurrences) => occurrences.setDisplayedOccurrences
  )

  const multipleAssistancesData = useContextSelector(
    OccurrencesModalContext,
    (occurrences) => occurrences.multipleAssistancesData
  )

  const setMultipleAssistancesData = useContextSelector(
    OccurrencesModalContext,
    (occurrences) => occurrences.setMultipleAssistancesData
  )

  return {
    close,
    isOpen,
    open,
    options,
    selectedOccurrences,
    setSelectedOccurrences,
    pendingConfirmOccurrence,
    setPendingConfirmOccurrence,
    modalContentTemplate,
    setModalContentTemplate,
    breadcrumbOccurrences,
    setBreadcrumbOccurrences,
    displayedOccurences,
    setDisplayedOccurrences,
    multipleAssistancesData,
    setMultipleAssistancesData,
  }
}
